module.exports = require("./ksb.d.ts");